import { ROUTES } from "../../../module/constants";
import { generalConst } from "../../../module/globalInterface";

export const EMERGENCY_USERS: generalConst = {
  BASE_URL: ROUTES.EMERGENCY_USERS,
  DETAIL: `${ROUTES.EMERGENCY_USERS}/detail`,
};

export const STATE_IDENTIFIER: generalConst = {
  EMERGENCY_USER_LIST: "emergencyUserList",
  DETAIL: "detail",
  USER: "user",
  CALL_STATE: "callState",
};

export const LIST_IDENTIFIER: string = "list";
export const LOADER_IDENTIFIER: string = "loader";
